import type { Nullable } from "models-webgl2";
import { addLineNumbersWithError } from "./add-line-numbers-with-error";

export const createProgram = (
  gl: WebGL2RenderingContext,
  shaders: [WebGLShader, WebGLShader],
  opt_attribs?: string[],
  opt_locations?: number[],
  opt_errorCallback?: (error: string) => void,
): Nullable<WebGLProgram> => {
  const errFn = opt_errorCallback || console.error;

  const program = gl.createProgram();

  // Something went wrong during program creation.
  if (!program) {
    errFn("Error while creating shader");
    return null;
  }

  shaders.forEach((shader) => gl.attachShader(program, shader));

  opt_attribs?.forEach((attrib, i) => {
    gl.bindAttribLocation(program, opt_locations?.[i] || i, attrib);
  });

  gl.linkProgram(program);

  // Check the link status
  const linked = gl.getProgramParameter(program, gl.LINK_STATUS);

  if (!linked) {
    const lastError = gl.getProgramInfoLog(program);

    errFn(
      `Error in program linking: ${lastError}\n${shaders
        .map((shader) => {
          const src = addLineNumbersWithError(gl.getShaderSource(shader) || "");
          const type = gl.getShaderParameter(shader, gl.SHADER_TYPE);
          return `${type}:\n${src}`;
        })
        .join("\n")}`,
    );

    gl.deleteProgram(program);

    return null;
  }

  shaders.forEach((shader) => gl.deleteShader(shader));

  return program;
};
